import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 185.69 206.04"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M133.06 0h52.63v206.04h-52.63zM63.22 138.62a65.5 65.5 0 0 0 59.25-71.2 65.5 65.5 0 0 0-59.25 71.2ZM0 0h52.63v206.04H0z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }